import {
  STREAMLAIN_BACKGROUND_ART_BOOT_GEOMETRY_STYLE,
  StreamLainBackgroundArt,
} from '../../brand';
import { authBackgroundArt, authBackgroundArtWrapper } from './share.css';

export function AuthBackgroundArts() {
  return (
    <div className={authBackgroundArtWrapper}>
      <StreamLainBackgroundArt
        className={authBackgroundArt}
        style={STREAMLAIN_BACKGROUND_ART_BOOT_GEOMETRY_STYLE}
      />
    </div>
  );
}
